export default __webpack_public_path__ + "static/media/cif-it.0827ba64.svg";